import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import Button from "../../../../Core/Button/Button.jsx";
import Table1 from "./Table1";
const Tab1 = ({
  pageState,
  handleChange,
  onInputChange,
  invoiceList,
  userList,
  CompanyList,
  errors,
  setselected_item_data,

  CostCenterList,
  list_data,
}) => {
  const statusList = [
    { name: "Passive" },
    { name: "Open" },
    { name: "Replied" },
  ];
  const getToday = () => {
    return new Date().toISOString().split("T")[0];
  };

  return (
    <div>
      <div className="px-3 pb-2 pt-4" style={{ background: "white" }}>
        <div className="mb-3" style={{ display: "flex", gap: "20px" }}>
          <div className="col-md-12" style={{ display: "flex" }}>
            <div className="col-md-6 px-2">
              <div
                className=""
                style={{
                  backgroundColor: "#EBE6FA",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                }}
              >
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="date"
                      label="Series"
                      style={{
                        height: "30px",
                      }}
                      value={getToday()}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="from_currency"
                      label="Customer"
                      style={{
                        height: "30px",
                      }}
                      placeholder="0.55555"
                    />
                  </div>
                </div>
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="date"
                      label="Date of Visit"
                      style={{
                        height: "30px",
                      }}
                      value={getToday()}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Company"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("Company", val)}
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 px-2">
              <div
                style={{
                  backgroundColor: "#E3F5DF",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                  gap: "15px",
                }}
              >
                {/* Row 1 */}

                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="from_currency"
                      label="Contact No "
                      style={{
                        height: "30px",
                      }}
                      value={getToday()}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Customer Type"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("Party", val)}
                      placeholder=""
                    />
                  </div>
                </div>

                {/* Row 2 */}
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Assigned To"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("AssignedTo", val)}
                      placeholder=""
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Help By"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("HelpBy", val)}
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tab1;
